export default __webpack_public_path__ + "static/media/give2.84a9c052.svg";